import { useEffect, useState } from 'react';
import { modulosService, type Modulo, type PlanoModulo } from '../services/modulosService';

export interface EstadoModulos {
  carregando: boolean;
  /** true enquanto carrega ou em erro: falha ABERTA na UX — o servidor é quem bloqueia. */
  liberado: (m: Modulo) => boolean;
  /** Nome do plano mais barato que libera o módulo, ou null. */
  planoMinimo: (m: Modulo) => string | null;
}

export function useModulos(): EstadoModulos {
  const [modulos, setModulos] = useState<Modulo[] | null>(null);
  const [planos, setPlanos] = useState<PlanoModulo[]>([]);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    let ativo = true;
    Promise.all([modulosService.meusModulos(), modulosService.planosPorModulo()])
      .then(([m, p]) => { if (ativo) { setModulos(m); setPlanos(p); } })
      .catch(() => { if (ativo) setModulos(null); })
      .finally(() => { if (ativo) setCarregando(false); });
    return () => { ativo = false; };
  }, []);

  return {
    carregando,
    liberado: m => modulos === null || modulos.includes(m),
    planoMinimo: m => planos.filter(p => p.modulo === m).sort((a, b) => a.preco_mensal - b.preco_mensal)[0]?.plano_nome ?? null,
  };
}
